import React from "react";
import { motion } from "framer-motion";

const tools = [
  { category: "Design / Paint", items: "Photoshop · Adobe Suite · Procreate" },
  { category: "AI Systems", items: "ComfyUI · WebUI · Nano Banana Workflows" },
  {
    category: "Image / Prompting",
    items: "MidJourney · Ideogram · Identity-Locked References",
  },
  { category: "Video / Motion", items: "Kling · Veo · Seedance" },
  { category: "Post / Edit", items: "After Effects · DaVinci Resolve" },
  {
    category: "Visual Language",
    items: "ARRI/Alexa Tonality · IMAX-Scale Composition",
  },
];

export default function ToolkitSection() {
  return (
    <section
      id="toolkit"
      data-testid="toolkit-section"
      className="py-24 sm:py-32 px-6 sm:px-12 relative overflow-hidden"
    >
      {/* Background accent image */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://images.pexels.com/photos/10395639/pexels-photo-10395639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt=""
          className="w-full h-full object-cover opacity-[0.04]"
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="section-number mb-4">04 &middot; Toolkit</p>
          <h2
            className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-none text-white max-w-3xl"
            data-testid="toolkit-heading"
          >
            Creative tools used in{" "}
            <span className="font-serif-accent text-amber-400">
              active production.
            </span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-neutral-400 leading-relaxed max-w-2xl">
            A hybrid stack covering ideation, image generation, video motion,
            paintover guidance, compositing, finishing, and editorial support.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-16">
          {tools.map((tool, i) => (
            <motion.div
              key={tool.category}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`toolkit-item-${i}`}
              className="glass-surface glass-surface-hover rounded-2xl p-6 transition-all duration-500 group"
            >
              <span className="text-xs font-mono tracking-[0.15em] uppercase text-amber-500/80 block mb-3">
                {tool.category}
              </span>
              <p className="font-mono text-sm text-white/40 group-hover:text-white/80 transition-colors duration-500 leading-relaxed">
                {tool.items}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
